// ver ejemplo de uso de pageContext en https://www.gatsbyjs.org/docs/creating-and-modifying-pages/#creating-pages-in-gatsby-nodejs
import { Link } from 'gatsby'
import React, { useEffect } from 'react'
import Layout from '../components/layout/LayoutCandidaturas'
import CandidatoCard from '../components/CandidatoCard'
import useSeleccionCombos from '../utils/useSeleccionCombos'
import SEO from '../components/SEO'
import ShareButtons from '../components/ShareButtons'

const candidatos = ({ pageContext }) => {
  const location = typeof window !== 'undefined' ? window.location : undefined
  const title = `Candidaturas a ${pageContext.nombrePuesto}${
    pageContext.descripcionProvincia ? ` de ${pageContext.descripcionProvincia}` : ''
  }${
    pageContext.descripcionCanton ? `, ${pageContext.descripcionCanton}` : ''
  }${
    pageContext.descripcionDistrito ? `, ${pageContext.descripcionDistrito}` : ''
  }, PARTIDO ${pageContext.partido.nombrePartido}`

  const {
    idPuestoSeleccionado,
    setIdPuestoSeleccionado,
    idProvinciaSeleccionada,
    setIdProvinciaSeleccionada,
    idCantonSeleccionado,
    setIdCantonSeleccionado,
    idDistritoSeleccionado,
    setIdDistritoSeleccionado,
  } = useSeleccionCombos()

  useEffect(() => {
    setIdPuestoSeleccionado(pageContext.seleccion.puesto)
    setIdDistritoSeleccionado(pageContext.seleccion.distrito)
    setIdCantonSeleccionado(pageContext.seleccion.canton)
    setIdProvinciaSeleccionada(pageContext.seleccion.provincia)
  }, [])

  return (
    <>
      <SEO title={title}></SEO>
      <section className="container mx-auto my-6 px-8 py-8 bg-gray-100 rounded-lg">
        <div className="flex flex-col xl:flex-row lg:-mx-3 items-start xs:justify-between">
          {/* breadcrumb */}
          <div className="mb-6 xl:mb-0 py-0 px-0 bg-gray-100 text-gray-900 rounded-md text-sm">
            <h1>
              <ul className="flex">
                <li>Está viendo candidaturas de:</li>
                <li>
                  <span className="mx-2"></span>
                </li>
                <li>{pageContext.nombrePuesto}</li>
                <li>
                  <span className="mx-2">/</span>
                </li>
                <li>
                  {pageContext.descripcionProvincia
                    ? pageContext.descripcionProvincia
                    : 'TODO EL PAÍS'}
                </li>

                {pageContext.descripcionCanton && (
                  <>
                    <li>
                      <span className="mx-2">/</span>
                    </li>
                    <li>{pageContext.descripcionCanton}</li>
                  </>
                )}

                {pageContext.descripcionDistrito && (
                  <>
                    <li>
                      <span className="mx-2">/</span>
                    </li>
                    <li>{pageContext.descripcionDistrito}</li>
                  </>
                )}

                <li>
                  <span className="mx-2">/</span>
                </li>
                <li>PARTIDO {pageContext.partido.nombrePartido}</li>
              </ul>
            </h1>
          </div>
          {/* breadcrumb */}
          <ShareButtons url={location?.href} title={title} description={title}></ShareButtons>
        </div>
        <div className="flex flex-col md:flex-row lg:-mx-3 items-start xs:justify-between">
          <Link className="mb-6 md:mb-0 mt-4 xl:mt-0" to={pageContext.rutaCandidatos}>
            Volver atrás a la lista de partidos
          </Link>
        </div>
      </section>

      <section className="container mx-auto my-6 px-8 py-8 bg-gray-100 rounded-lg text-center content-center">
        <div className="flex flex-wrap flex-col md:flex-row md:-mx-3">
          {pageContext.partido.candidatos.map((candidato, index) => (
            <div key={index} className="px-3">
              <CandidatoCard
                candidato={candidato}
                rutaBase={pageContext.rutaBase}
                partido={pageContext.partido}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  )
}
candidatos.Layout = Layout
export default candidatos
